import React, { useState } from 'react';

const ProfilingFilterBarV2 = ({ onFilterChange, setSelectedPlatforms  }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPlatforms, setSelectedPlatformsLocal] = useState([]);

  const platforms = [
    { name: "facebook", icon: "/icons/facebook.png" },
    { name: "instagram", icon: "/icons/instagram.png" },
    { name: "twitter", icon: "/icons/twitter.png" },
    { name: "tiktok", icon: "/icons/tiktok.png" },
  ];

 // Handle platform selection and send selected platforms to parent
 const handlePlatformChange = (platform) => {
    setSelectedPlatformsLocal((prev) => {
      const updatedPlatforms = prev.includes(platform)
        ? prev.filter((p) => p !== platform)
        : [...prev, platform];
      setSelectedPlatforms(updatedPlatforms);  // Update parent state
      onFilterChange({ selectedPlatforms: updatedPlatforms }); // Send updated platforms to parent
      return updatedPlatforms;
    });
  };

  // Handle search term change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    onFilterChange({ searchTerm: e.target.value, selectedPlatforms });
  };

  const resetFilters = () => {
    setSearchTerm(''); // Reset search term
    setSelectedPlatformsLocal([]); // Reset local selected platforms
    setSelectedPlatforms([]); // Reset parent selected platforms
    onFilterChange({ searchTerm: '', selectedPlatforms: [] }); // Reset the filters in the parent
  };
  

  // Filter Bar Styles
  const filterBarStyles = {
    padding: '10px 20px',
    backgroundColor: '#f0f4f8',
    borderRadius: '12px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.05)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: '1000px',
    margin: 'auto',
    fontFamily: "'Poppins', sans-serif",
    gap: '15px',
    transition: 'all 0.3s ease',
  };

  // Input field styles
  const searchInputStyles = {
    padding: '10px',
    fontSize: '14px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    width: '250px',
    backgroundColor: '#fff',
    transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
  };

  const searchInputFocusStyles = {
    borderColor: '#3498db',
    boxShadow: '0 0 5px rgba(52, 152, 219, 0.5)',
    outline: 'none',
  };

  // Platform icons container styles
  const platformOptionsStyles = {
    display: 'flex',
    gap: '15px',
    flex: '1',
    justifyContent: 'flex-end', // Align icons to the right
  };

  const platformLabelStyles = {
    cursor: 'pointer',
    transition: 'transform 0.3s ease',
  };

  const platformIconStyles = (selected) => ({
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    opacity: selected ? 1 : 0.7,
    transition: 'opacity 0.3s, transform 0.3s ease',
    border: selected ? '3px solid #3498db' : '3px solid transparent',
    boxShadow: selected ? '0px 4px 10px rgba(52, 152, 219, 0.3)' : 'none',
    transform: selected ? 'scale(1.1)' : 'scale(1)',
  });

  return (
    <div>
      {/* Filter Bar */}
      <div style={filterBarStyles}>
        {/* Search Input Section */}
        <div style={{ flex: 2, display: 'flex', gap: '10px', alignItems: 'center' }}>
          <label htmlFor="username" style={{ fontSize: '14px', fontWeight: '500', color: '#333', marginRight: '10px' }}>
            Enter Profile Username:
          </label>
          <input
            id="username"
            type="text"
            placeholder="Search by username"
            value={searchTerm}
            onChange={handleSearchChange}
            style={searchInputStyles}
            onFocus={(e) => e.target.style = { ...searchInputStyles, ...searchInputFocusStyles }}
            onBlur={(e) => e.target.style = searchInputStyles}
          />
        </div>

        <div style={platformOptionsStyles}>
          {platforms.map((platform) => (
            <label key={platform.name} style={platformLabelStyles}>
              <input
                type="checkbox"
                value={platform.name}
                onChange={() => handlePlatformChange(platform.name)}
                checked={selectedPlatforms.includes(platform.name)}
                style={{ display: 'none' }}
              />
              <img
                src={platform.icon}
                alt={platform.name}
                style={platformIconStyles(selectedPlatforms.includes(platform.name))}
                onMouseEnter={(e) => e.target.style.transform = 'scale(1.2)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              />
            </label>
          ))}
        </div>

        {/* Reset Button */}
        <button onClick={resetFilters} style={{ padding: '8px 12px', border: 'none', backgroundColor: '#e74c3c', color: '#fff', borderRadius: '8px', cursor: 'pointer' }}>
          Reset Filters
        </button>
      </div>
    </div>
  );
};

export default ProfilingFilterBarV2;
